export const cleanCheck = (data) => {
    if (!!data?.length)
        return data.filter((item) => !item.includes('Касир'));

    return '';
}